import LcFetch from "lib/shared/fetch";

const createBillingAgreement = () => {
  const url = "/paypal/billing_agreements";
  const fetchParams = {
    body: JSON.stringify({ subscription: window.subscriptionType }),
    method: "POST"
  };
  return LcFetch(url, fetchParams);
};

const reactivateRequests = {
  createBillingAgreement,
  createSubscription: (postData) => {
    const fetchParams = {
      body: JSON.stringify(postData),
      method: "POST"
    };
    return LcFetch("/subscription/renew", fetchParams);
  }
};

export { reactivateRequests };
